import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-h6 md:!text-h6" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const H6 = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <h6 data-testid={testId} className={base({ className })}>
      {children}
    </h6>
  );
};

export default H6;
